// !Do not remove the Layout import
import Layout from '@layouts/VerticalLayout'

const VerticalLayout = props => <Layout {...props}>{props.children}</Layout>

export default VerticalLayout
